<template>
    <div>
        <template v-if="subscription_fee_configuration === true">
            <div class="page-top mb-3 mt-3 clearfix">
                <router-link to="/addSoureWiseSubscriptionFeeComponent" class="btn btn-primary active float-right"> Add</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" companyName="" />
                </div>
            </div>
            <table id="SourceWiseSubscriptionFee" class="table" width="100%">
                <thead>
                <tr>
                    <th>On Board Source</th>
                    <th>Charges Type</th>
                    <th>fee</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th class="text-center">Action</th>
                </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="subscription_fee_configuration === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="subscription_fee_configuration === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                subscription_fee_configuration: null,
            };
        },
        methods: {
            sourceSubscriptionTable(){
                var SourceWiseSubscriptionFee = $('#SourceWiseSubscriptionFee').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/transactionAndSubscriptionCharges",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'onboardSourceName'},
                        {data: 'chargesType'},
                        {data: 'fee'},
                        {data: 'status'},
                        {data: 'created_at',
                            render: function(data,type,full){
                                if(full.created_at != null){
                                    return moment(full.created_at).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {data: 'updated_at',
                            render: function(data,type,full){
                                if(full.created_at != null){
                                    return moment(full.created_at).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = '/editSourceWiseSubscriptionFeeComponent/'+full['id'];
                                return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                SourceWiseSubscriptionFee.on('xhr', (event, settings, json) => {
                    if (json && json.records) {
                        json.records = json.records.filter(record => record.chargesType === 'SUBSCRIPTION');
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        SourceWiseSubscriptionFee.search(this.value).draw();
                    }
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('subscription_fee_configuration').then(result => {
                this.subscription_fee_configuration = result.subscription_fee_configuration;
            }).then(result => {
                if(this.subscription_fee_configuration == true){
                    this.sourceSubscriptionTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
